import { Link } from 'react-router-dom';

export const MobileMenu = ({ closeMobileMenu, title }) => {
  return (
    <div className='dash-mobile-menu-con'>
      <div className='mobile-menu-header'>
        <h2>LionTaxi</h2>
      </div>
      <div className='mobile-menu-list-con'>
        <ul>
          <li className={`menu-list-item ${title === 'overall' && 'active'}`}>
            <Link to='/admin/dashboard' onClick={closeMobileMenu}>
              <i className='fas fa-home'></i>
              <p>Dashboard</p>
            </Link>
          </li>
          <li className={`menu-list-item ${title === 'users' && 'active'}`}>
            <Link to='/admin/dashboard/users' onClick={closeMobileMenu}>
              <i className='fas fa-user'></i>
              <p>Users</p>
            </Link>
          </li>
          <li className={`menu-list-item ${title === 'rides' && 'active'}`}>
            <Link to='/admin/dashboard/rides' onClick={closeMobileMenu}>
              <i className='fas fa-car'></i>
              <p>Rides</p>
            </Link>
          </li>
          <li className={`menu-list-item ${title === 'drivers' && 'active'}`}>
            <Link to='/admin/dashboard/drivers' onClick={closeMobileMenu}>
              <i className='fas fa-user-tie'></i>
              <p>Drivers</p>
            </Link>
          </li>
          <li className={`menu-list-item ${title === 'feedbacks' && 'active'}`}>
            <Link to='/admin/dashboard/feedbacks' onClick={closeMobileMenu}>
              <i className='fas fa-comments'></i>
              <p>Feedbacks</p>
            </Link>
          </li>
          <li className={`menu-list-item ${title === 'settings' && 'active'}`}>
            <Link to='/admin/dashboard/settings' onClick={closeMobileMenu}>
              <i className='fas fa-cog'></i>
              <p>Settings</p>
            </Link>
          </li>
        </ul>
      </div>
      <div className='mobile-menu-footer'>
        <div className='mobile-menu-footer-con'>
          <div className='username'>
            <p>Elijah_Trillionz</p>
          </div>
          <div className='avatar'>
            <i className='fas fa-user'></i>
          </div>
        </div>
      </div>
    </div>
  );
};
